__webpack_require__.p = "/proto-actions-pane/";